import type { CalendarsTranslationMessages } from './calendarsTranslationMessages';

const personalCalendarsLanguageFrench: CalendarsTranslationMessages['me/calendars'] = {
  name: 'Calendriers',
  fields: {
    id: 'ID',
    description: 'Description',
    title: 'Titre',
    mode: 'Mode',
  },
  operations: {
    create: 'Créer calendrier',
    delete: 'Supprimer calendrier',
    edit: 'Modifier calendrier',
  },
};

const personalCalendarEventsLanguageFrench: CalendarsTranslationMessages['me/calendar_events'] = {
  name: 'Événements personnels',
  fields: {
    all_day: 'Toute la journée',
    calendar: 'Calendrier',
    description: 'Description',
    dtend: 'Fin',
    dtstart: 'Début',
    id: 'ID',
    metadata: 'Méta',
    title: 'Titre',
    tzid: 'Fuseau horaire',
    rrule: {
      count: "Nombre d'occurrences",
      freq: 'Fréquence',
      until: 'Date de fin des occurrences',
      bymonth: 'Occurrences dans les mois',
      bymonthday: 'Occurrences les jours du mois',
      byweekday: 'Occurrences les jours de la semaine',
      interval: 'Intervalle',
    },
    enableRrule: 'Activer la récurrence',
    recurrenceType: 'Type de récurrence',
  },
  operations: {
    create: 'Créer un événement',
    delete: "Supprimer l'événement",
    edit: "Modifier l'événement",
    sections: {
      details: "Informations sur l'événement",
      advancedSettings: 'Avancé',
    },
  },
  frequencies: {
    daily: 'Chaque jour',
    weekly: 'Chaque semaine',
    monthly: 'Chaque mois',
    yearly: 'Chaque année',
  },
  weekdays: {
    mo: 'Lundi',
    tu: 'Mardi',
    we: 'Mercredi',
    th: 'Jeudi',
    fr: 'Vendredi',
    sa: 'Samedi',
    su: 'Dimanche',
  },
  months: {
    1: 'Janvier',
    2: 'Février',
    3: 'Mars',
    4: 'Avril',
    5: 'Mai',
    6: 'Juin',
    7: 'Juillet',
    8: 'Août',
    9: 'Septembre',
    10: 'Octobre',
    11: 'Novembre',
    12: 'Décembre',
  },
  recurrenceTypes: {
    counted: "Nombre d'occurrences",
    until: "Jusqu'à une date",
  },
};

const domainCalendarsLanguageFrench: CalendarsTranslationMessages['calendars'] = {
  ...personalCalendarsLanguageFrench,
  fields: {
    ...personalCalendarsLanguageFrench.fields,
    owner: 'Propriétaire',
    labels: { id: 'Étiquettes', name: 'Étiquettes' },
  },
  operations: {
    ...personalCalendarsLanguageFrench.operations,
    sections: {
      details: 'Détails du calendrier',
    },
  },
};

const domainCalendarEventsLanguageFrench: CalendarsTranslationMessages['calendar_events'] = {
  ...personalCalendarEventsLanguageFrench,
  name: 'Événements',
};

export const calendarsLanguageFrench: CalendarsTranslationMessages = {
  'me/calendars': personalCalendarsLanguageFrench,
  'me/calendar_events': personalCalendarEventsLanguageFrench,
  calendars: domainCalendarsLanguageFrench,
  calendar_events: domainCalendarEventsLanguageFrench,
};
